module.exports = __webpack_public_path__ + "assets/img/hill-2.d9a7ed2f.png";